/**
 * „Externer Unterlagenordner" of a property (owner decision 19.10.2026, D-275): an https link to a folder
 * outside DAMOKLES (e.g. Google Drive), edited in „Objekt bearbeiten" and shown on „Objektunterlagen".
 */

export const DOCUMENTS_URL_MESSAGE = 'Bitte eine https-Adresse eingeben.';

/** Empty → null; otherwise an absolute https URL of at most 2048 characters (the API's limit). */
export function documentsUrlValue(value: string): { url: string | null; valid: boolean } {
  const trimmed = value.trim();
  if (trimmed === '') return { url: null, valid: true };
  if (trimmed.length > 2048) return { url: trimmed, valid: false };
  try {
    const parsed = new URL(trimmed);
    return { url: trimmed, valid: parsed.protocol === 'https:' && parsed.hostname !== '' };
  } catch {
    return { url: trimmed, valid: false };
  }
}

/** The host shown next to the folder icon („drive.google.com"); the whole text when it is no URL. */
export function folderHost(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}
